enum NfcTagTypeEnum {
	Skopei = 'skopei',
	External = 'external',
}

export default NfcTagTypeEnum;
